export default __webpack_public_path__ + "static/media/logo-senna-wordmark.876efa83.svg";